import * as PlansActionTypes from 'actiontypes/plans';


import deletePlanSuccess from './deletePlanSuccess';
import fetchPlansSuccess from './fetchPlansSuccess';
import saveEditSuccess from './saveEditSuccess';
import toggleEditMode from './toggleEditMode';

import { INITIAL_STATE } from './constants';


/**
 * Plans Reducer
 * @param {Object} state
 * @param {[Object]} action
 */
const Plans = (state = INITIAL_STATE, action) => {
  const { payload = {} } = action;

  switch (action.type) {
    case PlansActionTypes.FETCH_PLANS_REQUESTED:
      return { ...state, isFetching: true };

    case PlansActionTypes.FETCH_PLANS_FAILURE:
      return { ...state, isFetching: false };

    case PlansActionTypes.FETCH_PLANS_SUCCESS:
      return fetchPlansSuccess(state, payload);

    case PlansActionTypes.TOGGLE_EDIT_MODE:
      return toggleEditMode(state, payload);

    case PlansActionTypes.DELETE_PLAN_REQUESTED:
      return {
        ...state,
        isFetching: action.isFetching,
      };

    case PlansActionTypes.DELETE_PLAN_SUCCESS:
      return deletePlanSuccess(state, payload);

    case PlansActionTypes.DELETE_PLAN_FAILURE:
      return {
        ...state,
        isFetching: action.isFetching,
      };

    case PlansActionTypes.SAVE_EDIT_REQUESTED:
      return { ...state, isFetching: true };

    case PlansActionTypes.SAVE_EDIT_FAILURE:
      return { ...state, isFetching: false };

    case PlansActionTypes.SAVE_EDIT_SUCCESS:
      return saveEditSuccess(state, payload);

    case PlansActionTypes.FLUSH_PLANS:
      return {
        ...state,
        activePlans: null,
        completePlans: null,
      };

    default:
      return state;
  }
};

export default Plans;
